<template>

  <div class="dialog-main gm-page-content" v-bind="$attrs">
    <!-- 左侧：储能方阵内容区 -->

    <div class="left-content" v-if="deviceId && deviceType">
      <Eblock :arrayList="eLinkList" :getEBlockById="getEBlockById" />
    </div>

    <div class="left-content" v-else>
      <!-- 储能方阵折叠面板 - 使用自定义组件 -->
      <ArrayPanel v-for="(array, index) in eLinkList" :key="array.id" 
        :array-data="array" :default-expanded="true" @open-elink-detail="openElinkDetail"
        :getELinkIdByEBlockId="getELinkIdByEBlockId" />
    </div>

    <!-- 右侧：设备树 -->

    <DeviceTree :loading="loading" :items="items" v-model:selectedId="selectedId" @select="onSelect"
      :onlineStatus="onlineStatus"></DeviceTree>

  </div>



  <ElinkDetailDialog v-model="elinkDetailDialogVisible" :elink="currentElinkDetail" />
</template>

<script setup>
import { ref, computed, watch, onUnmounted, shallowRef, nextTick, inject, provide } from 'vue'
import ArrayPanel from '../../components/real-time-monitor/ArrayPanel.vue'
import { ws_req } from '@/ws/wss-request'
import useUserStore from '@/store/modules/user'
import { useRoute, useRouter } from 'vue-router'
import Eblock from './DeviceDetail/Eblock.vue'
import DeviceTree from './components/DeviceTree/index.vue'
import { useStationContext } from '../../composables/useStationContext'
import ElinkDetailDialog from '../../components/real-time-monitor/ElinkDetailDialog.vue'


import { useDeviceList } from '@/hooks/useDeviceList'
import { useRealData } from '@/hooks/useRealData'
import { dataMapKey } from './keys.js'


const router = useRouter()
const route = useRoute()
const deviceId = computed(() => route.query.deviceId)
const deviceType = computed(() => route.query.deviceType)
const stationId = computed(() => route.query.stationId)

if (deviceId.value && deviceType.value) {
  console.log('deviceId:', deviceId, 'deviceType:', deviceType)
}
const selectedId = ref([deviceId.value || ''])
const activeDeviceId = ref(route.query.deviceId)



async function onSelect(params) {
  console.log('params', params)

  // // 有设备ID，是详情页点击
  if (deviceId.value) {
    const type = getDeviceTypeById(params.id)
    if (type == 'eBlock') {
      router.replace({
        path: '/station-monitor/detail',
        query: {
          ...route.query,
          elinkId: getELinkIdByEBlockId(params.id),
          deviceId: params.id,
          deviceType: type
        }
      })
    }
    return
  }
  await highLightDevice(params.id)
}

async function highLightDevice(id) {
  await nextTick()
  const element = document.querySelector(`[data-device-id="${id}"]`)
  if (element) {

    // 滚动
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    // 执行动画 闪烁3次
    element.animate(
      [
        { boxShadow: 'none', borderColor: 'rgba(244, 247, 252, 1)' },
        { boxShadow: '0 0 12px rgba(58, 104, 255, 0.5)', borderColor: 'rgba(58, 104, 255, 1)' },
      ],
      { duration: 500, easing: 'ease-in-out', iterations: 4, direction: 'alternate-reverse' }
    )
  }
}


// eLink详情弹框
const elinkDetailDialogVisible = ref(false)
const currentElinkDetail = ref(null)

const openElinkDetail = (elink) => {
  currentElinkDetail.value = elink
  elinkDetailDialogVisible.value = true
}

// 使用 composable 获取电站上下文信息
const { stationId: currentStationId, stationName: currentStationName } = useStationContext()



const { items, eLinkList, loading, getDeviceTypeById, getEBlockById, getELinkIdByEBlockId, getELinkById } = useDeviceList({
  showESSDevice: true,
  showOtherDevices: false,
})


const dataMap = ref({})
provide(dataMapKey, dataMap)
const { realData, updateOnce } = useRealData({
  initData: [],
  updateFunction() {
    return ws_req.request('elink_eblock_overview', {
      stationId: Number(currentStationId.value),
      eMindV3: '1',
    })
  },
  onUpdate(data) {
    for (const dt of data) {
      const key = dt.eLink.uuid
      const eLink = dt.eLink
      dataMap.value[key] = eLink
      for (const eb of dt.eBlockList) {
        const k = eb.uuid
        dataMap.value[k] = eb
      }
    }
  }
})

// 电站ID变化时，立即更新一次实时数据
watch(() => currentStationId.value, () => {
  updateOnce()
})


const onlineStatus = computed(() => {
  const map = {}
  realData.value.forEach(item => {
    item.eBlockList.forEach(block => {
      map[block.uuid] = block.online !== void 0
    })
    map[item.eLink.uuid] = item.eLink.run_st !== void 0
  })
  return map
})



</script>

<style scoped lang="scss">
.energy-storage-detail-dialog {
  :deep(.v-overlay__content) {
    width: 100vw !important;
    max-width: 1920px !important;
    height: 950px !important;
    margin: 0 auto !important;
    border-radius: 30px 30px 0 0 !important;
  }
}

.dialog-wrapper {
  position: relative;
  width: 100%;
  height: 950px;
  padding: 20px 24px 0;
  background-color: #fff !important;
  background: url('@/assets/images/station-monitor/detail-dialog/detail-bg.svg') no-repeat center center;
  background-size: cover;
  border-radius: 30px 30px 0 0 !important;
}

.dialog-title {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 20px;
  color: rgba(46, 46, 46, 1);
  font-weight: normal;
  margin-bottom: 20px;
  padding-left: 24px;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 24px;
  z-index: 10;
}

.dialog-main {
  display: flex;
  flex-direction: row-reverse;
  gap: 16px;
  min-width: 0;
  max-width: 100%;
  // height: calc(100% - 83px);
  // background: rgba(246, 251, 255, 1);
  border-radius: 30px;
  // padding: 20px;
}

/* 左侧内容区 - 性能优化 */
.left-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* 开启硬件加速，优化滚动性能 */
  will-change: scroll-position;
  transform: translateZ(0);
  -webkit-overflow-scrolling: touch;
  /* 确保flex容器可以滚动 */
  min-height: 0;
  min-width: 0;
  height: calc(100vh - var(--header-height) - 150px);
  // border: 1px solid red;
}

/* 右侧边栏 */
.right-sidebar {
  width: 319px;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.search-wrapper {
  position: relative;
  margin-bottom: 26px;
}

.search-input {
  width: 100%;
}

.device-tree {
  overflow-y: auto;
  height: calc(100vh - var(--header-height) - 250px);
  // border: 1px solid red;
  min-height: 300px;
}

@media (max-width: 1024px) {
  .dialog-main {
    flex-direction: column;
  }

  .left-content {
    height: auto;
    min-height: 0;
  }
}

@media (max-width: 768px) {
  .dialog-main {
    gap: 12px;
    border-radius: 20px;
  }
}

.device-name {
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
  line-height: normal;
}

.device-uuid {
  font-size: 12px;
  color: #2e2e2e99;
  line-height: normal;
}

.custom-treeview {
  :deep(.v-treeview-item) {
    margin-bottom: 8px;
  }

  :deep(.v-treeview-item__label) {
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    line-height: normal;
  }

  :deep(.v-treeview-item--active) {
    background: rgba(239, 242, 254, 1);
    border-radius: 3px;

    .v-treeview-item__label {
      color: rgba(58, 104, 255, 1);
    }
  }

  :deep(.v-treeview-item__prepend) {
    margin-right: 9px;
  }
}
</style>
